import styles from "./ChatTips.module.scss";

export interface Props {
  onLinkClicked: () => void;
}

export function ChatTips(props: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.plainText}>Please chat to a professional for medical, legal, or financial advice. </div>
      <div className={styles.linkText} onClick={() => props.onLinkClicked()}>
        Read our full disclaimer.
      </div>
    </div>
  );
}
